/* Original LÉ DETOX interactions. No storefront dependencies. */
document.documentElement.classList.replace('no-js', 'js');
(() => {
  const openers = new WeakMap();
  const observedHeaders = new WeakSet();
  const hoveredHeaders = new WeakSet();
  const headerHover = matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
  const headerObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const header = document.querySelector('[data-header]');
      if (!header) continue;
      const group = header.closest('.shopify-section-group-header-group');
      const announcement = document.querySelector('.announcement')?.offsetHeight || 0;
      const nav = header.offsetHeight;
      group.style.setProperty('--announcement-height', announcement + 'px');
      group.style.setProperty('--nav-height', nav + 'px');
      document.documentElement.style.setProperty('--header-height', (nav + announcement) + 'px');
      document.documentElement.style.setProperty('--announcement-height', announcement + 'px');
      document.documentElement.style.setProperty('--nav-height', nav + 'px');
    }
  });
  const syncScrollLock = () => document.body.classList.toggle('dialog-open', !!document.querySelector('dialog[open]'));
  function close(dialog) { dialog.close(); }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (!dialog) return;
      openers.set(dialog, opener);
      dialog.showModal();
      syncScrollLock();
      return;
    }
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) close(closer.closest('dialog'));
    const dialog = event.target.closest('dialog');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(dialog);
    }
    if (dialog && event.target.closest('a[href]')) close(dialog);
    const summary = event.target.closest('.footer-menu > summary');
    if (summary && matchMedia('(min-width: 768px)').matches) event.preventDefault();
  });
  document.addEventListener('close', event => {
    if (event.target.tagName !== 'DIALOG') return;
    syncScrollLock();
    const opener = openers.get(event.target);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('.localization-form select')) event.target.form.requestSubmit();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const dialog = document.querySelector('dialog[open]');
    if (!dialog) return;
    const focusable = [...dialog.querySelectorAll('a[href], button:not(:disabled), input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled), summary, [tabindex]:not([tabindex="-1"])')]
      .filter(element => element.tabIndex >= 0 && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });
  function initialize(root = document) {
    // Merchant-authored rich text and menu links can be external as well as internal.
    // Keep external destinations in a new tab without changing mailto or store links.
    root.querySelectorAll('a[href]').forEach(link => {
      let destination;
      try { destination = new URL(link.getAttribute('href'), location.href); } catch { return; }
      if (!['http:', 'https:'].includes(destination.protocol)) return;
      const internalHosts = [location.hostname, document.documentElement.dataset.shopHost, document.documentElement.dataset.shopPermanentHost].filter(Boolean).map(host => host.replace(/^www\./, '').toLowerCase());
      const destinationHost = destination.hostname.replace(/^www\./, '').toLowerCase();
      if (internalHosts.includes(destinationHost)) return;
      // Shopify's hosted customer accounts use a shopify.com URL but are store navigation.
      if (destinationHost === 'shopify.com' && /\/account(?:\/|$)/.test(destination.pathname)) return;
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
    root.querySelectorAll('.site-footer').forEach(footer => footerObserver.observe(footer));
    updateFooterReveal();
    root.querySelectorAll('[data-header]').forEach(header => {
      if (!observedHeaders.has(header)) {
        headerObserver.observe(header);
        const announcement = document.querySelector('.announcement');
        if (announcement) headerObserver.observe(announcement);
        header.addEventListener('pointerenter', event => {
          if (!headerHover.matches || event.pointerType === 'touch' || header.dataset.headerOverlay !== 'true') return;
          header.style.setProperty('--header-hover-row-height', header.querySelector('.header-row').offsetHeight + 'px');
          hoveredHeaders.add(header);
          updateHeader();
        });
        header.addEventListener('pointerleave', () => {
          header.style.removeProperty('--header-hover-row-height');
          hoveredHeaders.delete(header);
          updateHeader();
        });
        observedHeaders.add(header);
      }
    });
    root.querySelectorAll('.footer-menu').forEach(details => {
      details.open = matchMedia('(min-width: 768px)').matches;
      details.querySelector('summary').tabIndex = details.open ? -1 : 0;
    });
    updateHeader();
    updateNavigation();
  }
  function updateNavigation() {
    document.querySelectorAll('.nav-list a[href], .footer-menu a[href]').forEach(link => {
      const target = new URL(link.href, location.href);
      if (!target.hash) return;
      const active = target.origin === location.origin && target.pathname === location.pathname && target.hash === location.hash && !new URLSearchParams(location.search).has('view');
      if (active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }
  window.addEventListener('hashchange', updateNavigation);
  function updateHeader() {
    const extent = document.documentElement.scrollHeight - innerHeight;
    const progress = document.querySelector('[data-scroll-progress]');
    if (progress) progress.parentElement.hidden = scrollY <= 0;
    if (progress) progress.style.transform = `scaleX(${extent > 0 ? Math.min(1, scrollY / extent) : 0})`;
    const back = document.querySelector('[data-back-top]');
    if (back) {
      const visible = extent > 0 && scrollY >= 12;
      back.hidden = !visible;
      back.inert = !visible;
    }
    document.querySelectorAll('[data-header]').forEach(header => {
      const announcementHeight = document.querySelector('.announcement')?.offsetHeight || 0;
      const hovered = headerHover.matches && hoveredHeaders.has(header) && header.dataset.headerOverlay === 'true';
      header.classList.toggle('is-header-hovered', hovered);
      header.classList.toggle('is-scrolled', window.scrollY > announcementHeight || hovered);
      header.closest('.shopify-section-group-header-group')?.classList.toggle('sticky-group', header.classList.contains('header--sticky'));
    });
  }
  headerHover.addEventListener('change', () => {
    document.querySelectorAll('[data-header]').forEach(header => {
      header.style.removeProperty('--header-hover-row-height');
      hoveredHeaders.delete(header);
    });
    updateHeader();
  });
  let scheduled = false;
  window.addEventListener('scroll', () => {
    if (!scheduled) requestAnimationFrame(() => { updateHeader(); scheduled = false; });
    scheduled = true;
  }, { passive: true });
  matchMedia('(min-width: 768px)').addEventListener('change', () => initialize());
  matchMedia('(min-width: 1280px)').addEventListener('change', () => {
    document.querySelectorAll('.menu-panel[open]').forEach(close);
  });
  document.addEventListener('shopify:section:load', event => {
    initialize(event.target);
    event.target.querySelectorAll('.announcement').forEach(announcement => headerObserver.observe(announcement));
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-header],.announcement').forEach(element => headerObserver.unobserve(element));
    event.target.querySelectorAll('.site-footer').forEach(footer => footerObserver.unobserve(footer));
    requestAnimationFrame(syncScrollLock);
  });
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function updateFooterReveal() {
    const footer = document.querySelector('.site-footer');
    document.body.classList.toggle('footer-curtain', !!footer && footer.dataset.footerReveal === 'true' && !reducedMotion.matches && innerWidth >= 990 && footer.getBoundingClientRect().height < innerHeight - 32);
  }
  const footerObserver = new ResizeObserver(updateFooterReveal);
  reducedMotion.addEventListener('change', updateFooterReveal);
  document.addEventListener('click', event => {
    document.querySelectorAll('.localization-popover[open]').forEach(popover => {
      if (!popover.contains(event.target)) popover.open = false;
    });
    if (event.target.closest('[data-back-top]')) {
      window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      document.querySelector('.header-logo')?.focus({ preventScroll: true });
    }
    const announcementClose = event.target.closest('[data-announcement-close]');
    if (announcementClose) {
      const announcement = announcementClose.closest('.announcement');
      announcement.hidden = true;
      updateHeader();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const popover = document.querySelector('.localization-popover[open]');
    if (popover) { event.preventDefault(); event.stopPropagation(); popover.open = false; popover.querySelector('summary').focus(); }
  }, true);
  window.addEventListener('resize', updateHeader);
  window.addEventListener('resize', updateFooterReveal);
  initialize();
})();

/* Upcart public cart-state events. Observe confirmed updates, never intercept forms
 * or requests. Public cart items include quantity; they do not expose item_count.
 * Register independently of Upcart's script load order and keep one subscription.
 */
(() => {
  if (window.leDetoxCartCount) return;
  let count = null;
  function render() {
    if (count === null) return;
    document.querySelectorAll('[data-cart-link]').forEach(link => {
      const badge = link.querySelector('[data-cart-count]');
      if (badge) {
        badge.textContent = String(count);
        badge.hidden = count === 0;
      }
      link.setAttribute('aria-label', `${link.dataset.cartLabel} (${count})`);
    });
  }
  function update(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    const quantities = cart.items.map(item => item.quantity);
    if (quantities.some(quantity => !Number.isInteger(quantity) || quantity < 0)) return;
    count = quantities.reduce((total, quantity) => total + quantity, 0);
    render();
  }
  window.leDetoxCartCount = { refresh: render };
  const onCartState = event => update(event.detail?.cart);
  window.addEventListener('aftersell-upcart:public-events:cart-loaded', onCartState);
  window.addEventListener('aftersell-upcart:public-events:cart-updated', onCartState);
  // Read the current public state if Upcart loaded before this deferred script.
  function readCurrentCart() {
    if (typeof window.upcartGetCart === 'function') update(window.upcartGetCart());
  }
  readCurrentCart();
  window.addEventListener('pageshow', readCurrentCart);
  document.addEventListener('shopify:section:load', render);
})();

